document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".swiper-track");
  const slides = document.querySelectorAll(".swiper-slide");
  const nextBtn = document.querySelector(".swiper-next");
  const prevBtn = document.querySelector(".swiper-prev");

  // Exit early if required elements are missing
  if (!track || slides.length === 0) return;

  const slideWidth = slides[0].offsetWidth;
  let index = 0;
  let timer;

  function goToSlide(i) {
    track.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
    index = i;
  }

  function nextSlide() {
    index = (index + 1) % slides.length;
    goToSlide(index);
  }

  function prevSlide() {
    index = (index - 1 + slides.length) % slides.length;
    goToSlide(index);
  }

  function startAutoScroll() {
    timer = setInterval(nextSlide, 3000);
  }

  function stopAutoScroll() {
    clearInterval(timer);
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      stopAutoScroll();
      nextSlide();
      startAutoScroll();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      stopAutoScroll();
      prevSlide();
      startAutoScroll();
    });
  }

  // Only respond to horizontal (X) wheel input
  track.addEventListener("wheel", e => {
    // Only intercept if scrolling *horizontally*
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      e.preventDefault(); // Prevent browser from scrolling horizontally
      stopAutoScroll();
      if (e.deltaX > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
      startAutoScroll();
    }
    // Let vertical scrolling pass through
  }, { passive: false });

  startAutoScroll();
});


document.addEventListener("DOMContentLoaded", () => {

  const carouselBanners = document.querySelectorAll('.banner-with-carousel');

  const isMobile = window.matchMedia('(max-width: 990px)').matches;

  carouselBanners.forEach(banner => {
    const interval = parseInt(banner.dataset.interval, 10) * 1000;
    const autoplay = banner.dataset.autoplay !== 'false';

    initCarousel(banner,{
      interval,
      autoplay,
      isMobile
    });
  });

  function initCarousel(banner,options) {
    const config = {
      interval: 5000,
      autoplay: true,
      isMobile: false,
      parallaxFactor: 100,
      ...options
    };
    banner.classList.toggle('is-mobile', config.isMobile);
    const emblaNode = banner.querySelector('.embla.carousel-image-list');
    if(!emblaNode) {
      console.warn('Carousel container not found');
      return;
    }
    const dataId = emblaNode.dataset.carouselId;
    const textItems = banner.querySelectorAll(`.carousel-text-list[data-carousel-id="${dataId}"]>li`);
    const dotsContainer = banner.querySelector('.embla__dots');
    const slides = emblaNode.querySelectorAll('.embla__slide');
    const slideCount = slides.length;
    const mobileTextElements = Array.from(slides).map(slide =>
        slide.querySelector('.mobile-show-text')
    );
    if (textItems.length !== slideCount) {
      console.warn('The number of carousel images does not match the number of text items');
    }

    const emblaOptions = {
      axis:"x",
      containScroll: false
    }

    const plugins = [];
    if(!config.isMobile) {
      plugins.push(EmblaCarouselFade()); // PC fade effect
    }

    let autoplayPlugin = null;
    if (config.autoplay) {
      autoplayPlugin = EmblaCarouselAutoplay({
        delay: config.interval,
        stopOnInteraction: !config.isMobile // 移动端不停止，PC端停止
      });
      plugins.push(autoplayPlugin);
    }
    const emblaApi = EmblaCarousel(emblaNode, emblaOptions, plugins)

    function applyParallax() {
      // 获取当前滚动位置和轮播容器宽度
      const scrollProgress = emblaApi.scrollProgress();
      const PRECISION_THRESHOLD = 0.001;

      const normalizedProgress = Math.abs(scrollProgress % 1) < PRECISION_THRESHOLD
          ? Math.round(scrollProgress)
          : scrollProgress;

      mobileTextElements.forEach((textEl, slideIndex) => {
        if (!textEl) return; // 跳过没有文本元素的幻灯片
        const centerPos = slideIndex / (slideCount - 1);

        const diff = centerPos - normalizedProgress;

        textEl.style.transform = `translateX(${diff * config.parallaxFactor}px)`;
      });
    }
    applyParallax();

    function syncTextWithSlide() {
      const activeIndex = emblaApi.selectedScrollSnap();
      textItems.forEach((item, index) => {
        item.classList.toggle('active', index === activeIndex);
      });
    }

    function syncDots(){
      const dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === emblaApi.selectedScrollSnap());
      });
    }

    if(!config.isMobile) {
      syncTextWithSlide();
      emblaApi.on('select', syncTextWithSlide);
    }else{
      syncDots();
      emblaApi.on('scroll', applyParallax);
      emblaApi.on('select', syncDots);
    }

    textItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        console.log(index,emblaApi.selectedScrollSnap())
        if (emblaApi.selectedScrollSnap() !== index) {
          emblaApi.scrollTo(index);
          autoplayPlugin && autoplayPlugin.stop();
        }
      });
    });

    function debounce(func, delay = 200) {
      let timer = null;
      return function(...args) {
        // 如果已有定时器，清除它
        if (timer) clearTimeout(timer);
        // 重新设置定时器，延迟执行
        timer = setTimeout(() => {
          func.apply(this, args);
          timer = null;
        }, delay);
      };
    }

    window.addEventListener('resize', debounce(() => {
      const isNowMobile = window.matchMedia('(max-width: 990px)').matches;
      if (isNowMobile !== config.isMobile) {
        emblaApi.destroy();
        initCarousel(banner, { ...options, isMobile: isNowMobile });
      }
    }),300);

  }



})
